import { createAsyncThunk } from "@reduxjs/toolkit";
import getDataSummaryCredit from "../../../../configs/apis/data-summary/get-data-summary-credit.api";
import { getMonthOptions } from "../../utils/date-utils";

export const FETCH_DATA_SUMMARY = "dataSummary/fetchData";
export const FETCH_EXPORT_DATA = "dataSummary/fetchExportData";

export const fetchDataSummary = createAsyncThunk(
  FETCH_DATA_SUMMARY,
  async (
    { year, month, fromDay, toDay, dateRangeStart, dateRangeEnd, page, length },
    { rejectWithValue }
  ) => {
    try {
      const data = await getDataSummaryCredit({
        year,
        month,
        fromDay,
        toDay,
        dateRangeStart,
        dateRangeEnd,
        page,
        length,
        monthOptions: getMonthOptions(),
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchExportData = createAsyncThunk(
  FETCH_EXPORT_DATA,
  async (
    { year, month, fromDay, toDay, dateRangeStart, dateRangeEnd },
    { dispatch }
  ) => {
    try {
      dispatch({ type: "dataSummary/setIsExporting", payload: true });
      const response = await getDataSummaryCredit({
        year,
        month,
        fromDay,
        toDay,
        dateRangeStart,
        dateRangeEnd,
        page: 0,
        length: 10000,
        monthOptions: getMonthOptions(),
      });
      return response.records || [];
    } catch (error) {
      return [];
    } finally {
      dispatch({ type: "dataSummary/setIsExporting", payload: false });
    }
  }
);
